import { ONBOARDING_CHECK_STATUSES } from '../verifyOnboardingData'
import styles from './OnboardingVerification.module.scss'

const statusStyles = {
  [ONBOARDING_CHECK_STATUSES.ok]: styles.ok,
  [ONBOARDING_CHECK_STATUSES.warning]: styles.warning,
  [ONBOARDING_CHECK_STATUSES.unknown]: styles.unknown
}

const statusLabels = {
  [ONBOARDING_CHECK_STATUSES.ok]: 'OK',
  [ONBOARDING_CHECK_STATUSES.warning]: 'CHECK',
  [ONBOARDING_CHECK_STATUSES.unknown]: 'UNKNOWN'
}

const OnboardingVerification = ({ verification }) => {
  if (!verification || verification.checks.length === 0) {
    return null
  }

  const numberOfWarnings = verification.checks.filter(
    check => check.status === ONBOARDING_CHECK_STATUSES.warning
  ).length

  return (
    <div className={styles.panel} role="status">
      <div className={styles.header}>
        <span className={styles.dots}>
          {verification.checks.map(check => (
            <span
              key={check.key}
              className={[styles.dot, statusStyles[check.status]].join(' ')}
              title={`${check.title}: ${check.message}`}
            />
          ))}
        </span>
        <span className={styles.title}>Verify onboarding status</span>
        <span className={styles.summary}>
          {numberOfWarnings === 0
            ? 'Uploaded data looks consistent'
            : numberOfWarnings === 1
            ? '1 check needs attention'
            : `${numberOfWarnings} checks need attention`}
        </span>
      </div>

      <ul className={styles.checks}>
        {verification.checks.map(check => (
          <li key={check.key} className={styles.check}>
            <span className={[styles.status, statusStyles[check.status]].join(' ')}>
              {statusLabels[check.status]}
            </span>
            <span className={styles.checkText}>
              <span className={styles.checkTitle}>{check.title}</span>
              <span className={styles.checkMessage}>{check.message}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default OnboardingVerification
